"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const nucleus_1 = require("@lifesize/nucleus");
const c = __importStar(require("../constants/calendar"));
const redux_1 = require("../utils/redux");
const calendar_1 = require("../utils/calendar");
const calendar_2 = require("../utils/calendar");
exports.initialState = {
    enabled: false,
    events: [],
    activeEvents: [],
    todayEvents: [],
    tomorrowEvents: [],
    unsubscribed: true
};
exports.default = redux_1.createReducer(exports.initialState, {
    [nucleus_1.nucleusConstants.AUTH_LOGOUT]: () => exports.initialState,
    [nucleus_1.nucleusConstants.INIT_NUCLEUS]: (state, action) => {
        var _a, _b;
        const enabled = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.calendarEnabled, (_b !== null && _b !== void 0 ? _b : false));
        return Object.assign(Object.assign({}, state), { enabled });
    },
    [c.CALENDAR_UPDATE]: (state, action) => {
        const events = action.payload;
        const calendarEvents = calendar_1.setCalendarEvents(events);
        return Object.assign(Object.assign({}, state), { events: calendarEvents, activeEvents: calendar_2.getCalendarActiveEvents(calendarEvents), todayEvents: calendar_2.getCalendarTodayEvents(calendarEvents), tomorrowEvents: calendar_2.getCalendarTomorrowEvents(calendarEvents), unsubscribed: events === c.CALENDAR_NO_SUBSCRIPTION });
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/reducers/calendar.js
// module id = 603
// module chunks = 0